import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import * as form from '../../app/modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as user from '../../app/modules/insurance/healthInsurance/redux/userRedux'
import * as component from '../../app/components/redux/componentRedux'
import * as report from '../../app/modules/report/reportComponent/redux/reportRedux'
import * as submit from '../../app/modules/report/reportComponent/redux/gridRedux'
import * as common from '../../app/redux-commons/index'
import * as auto from '../../app/modules/insurance/AutoInsurance/redux/autoRedux'
import * as moto from '../../app/modules/insurance/MotoInsurance/redux/motoRedux'
import * as bancas from '../../app/modules/Bancassurance/redux/reducers'
import * as product from '../../app/modules/insurance/InsuranceProducts/redux/productRedux'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  form: form.personInsuReducer,
  user: user.userReducer,
  component: component.componentReducer,
  grid: common.gridReducer,
  report: report.reportReducer,
  gridSubmit: submit.gridReducer,
  filter: common.filterReducer,
  auto: auto.autoInsuReducer,
  moto: moto.motoInsuReducer,
  bancas: bancas.bancasReducer,
  product: product.productInsuReducer
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([
    form.saga(),
    user.saga(),
    auth.saga(),
    common.gridSaga(),
    report.saga(),
    submit.saga(),
    auto.saga(),
    moto.saga(),
    bancas.saga(),
    product.saga(),
  ])
}
